import {Box, Button, Card, CardContent, Chip, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {PortalShell} from '../../shared/ui';

export default function EmptyPortalPage({title, description}) {
    const navigate = useNavigate();
    return (
        <PortalShell title={title} subtitle="Portal do Cliente">
            <Card sx={{maxWidth: 760}}>
                <CardContent sx={{p: {xs: 3, md: 5}}}>
                    <Stack spacing={2.5}>
                        <Chip label="Em evolução" color="primary" variant="outlined" sx={{alignSelf: 'flex-start'}} />
                        <Box>
                            <Typography variant="h4" sx={{mb: 1.25}}>{title}</Typography>
                            <Typography color="text.secondary">{description}</Typography>
                        </Box>
                        <Button variant="contained" sx={{alignSelf: 'flex-start'}} onClick={() => navigate('/')}>Voltar ao dashboard</Button>
                    </Stack>
                </CardContent>
            </Card>
        </PortalShell>
    );
}
